import React from 'react';

const personalityData = {
    serene: {
        title: "The Simple & Serene",
        motto: "Less is more, and calm is everything.",
        description: "You thrive in environments that are calm, orderly, and clutter-free. For you, home is a sanctuary where you can recharge, and you believe that a simple space leads to a clear mind. You're drawn to functionality, clean lines, and the quiet beauty of natural materials.",
        dna: {
            styles: ["Scandinavian", "Japandi", "Minimalist"],
            palette: ["White", "Beige", "Light Gray", "Oak"],
            materials: ["Light Woods", "Linen", "Matte Metal", "Concrete"],
            mantra: "Embrace the space."
        },
        // CHANGED: Full URL is now included
        collectionUrl: "https://www.lunafurn.com/collections/simple-and-serene"
    },
    elegant: {
        title: "The Elegant & Timeless",
        motto: "Quality is an investment in the future.",
        description: "You appreciate the finer things in life: impeccable craftsmanship, high-quality materials, and timeless design. You're not swayed by fleeting trends. Instead, you invest in sophisticated pieces that exude quiet luxury and will look just as beautiful in twenty years as they do today.",
        dna: {
            styles: ["Contemporary", "Transitional", "Modern Classic"],
            palette: ["Charcoal", "Walnut", "Marble", "Brass"],
            materials: ["Dark Woods", "Marble", "Brass", "High-Performance Weaves"],
            mantra: "Buy nice, not twice."
        },
        // CHANGED: Full URL is now included
        collectionUrl: "https://www.lunafurn.com/collections/elegant-and-timeless"
    },
    curator: {
        title: "The Characterful Curator",
        motto: "My home is my story.",
        description: "You see your home as a stage for self-expression. Rules are meant to be broken, and your space is a collection of unique finds, bold colors, and interesting objects that tell the story of your life. You're drawn to pieces with personality and aren't afraid to mix styles, eras, and patterns.",
        dna: {
            styles: ["Eclectic", "Maximalist", "Industrial", "Vintage"],
            palette: ["Emerald", "Navy", "Mustard", "Rich Woods"],
            materials: ["Velvet", "Reclaimed Wood", "Dark Metal", "Leather"],
            mantra: "More is more."
        },
        // CHANGED: Full URL is now included
        collectionUrl: "https://www.lunafurn.com/collections/characterful-curator"
    },
    pragmatic: {
        title: "The Pragmatic & Social",
        motto: "A smart home is a happy home.",
        description: "For you, a home must first and foremost serve the life you live. You value practical, durable, and flexible solutions that make everyday life easier, whether that means hosting friends for a game night or creating a kid-and-pet-friendly zone. You seek out smart, multi-functional furniture that is built to last.",
        dna: {
            styles: ["Casual Contemporary", "Family-Friendly", "Transitional"],
            palette: ["Gray", "Blue", "Wood Tones", "Durable Neutrals"],
            materials: ["Performance Fabrics", "Engineered Wood", "Rounded Corners", "Storage Solutions"],
            mantra: "Function over form."
        },
        // CHANGED: Full URL is now included
        collectionUrl: "https://www.lunafurn.com/collections/pragmatic-and-social"
    }
};


function ResultsPage({ finalScores }) {

    const getWinner = (scores) => {
        let winner = 'serene';
        let maxScore = 0;
        for (const personality in scores) {
            if (scores[personality] > maxScore) {
                maxScore = scores[personality];
                winner = personality;
            }
        }
        return winner;
    };

    const winnerKey = getWinner(finalScores);
    const resultData = personalityData[winnerKey];


    const styles = {
        container: { maxWidth: '900px', margin: 'auto', textAlign: 'center', padding: '0 1rem 2rem' },
        header: { borderBottom: '1px solid #eee', paddingBottom: '1rem', marginBottom: '2rem' },
        dnaSection: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', textAlign: 'left', background: '#f9f9f9', padding: '2rem', borderRadius: '8px', marginTop: '2rem' },
        ctaSection: { margin: '3rem 0', padding: '2rem', background: '#f0f0f0', borderRadius: '8px' },
        ctaButton: { textDecoration: 'none', background: '#ff7500', color: '#fff', padding: '1rem 2rem', fontSize: '1.2rem', fontWeight: 'bold', borderRadius: '5px', display: 'inline-block', border: 'none', cursor: 'pointer' },
        restartButton: { textDecoration: 'none', background: 'transparent', color: '#555', border: '1px solid #ccc', padding: '0.75rem 1.5rem', fontSize: '1rem', borderRadius: '5px', marginTop: '1.5rem', cursor: 'pointer', display: 'inline-block' }
    };

    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <p>YOUR FURNITURE PERSONALITY IS:</p>
                <h1 style={{ margin: '0', fontSize: '3rem' }}>{resultData.title}</h1>
                <p style={{ fontSize: '1.2rem', fontStyle: 'italic', color: '#555' }}>"{resultData.motto}"</p>
            </header>

            <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>{resultData.description}</p>

            <div style={styles.dnaSection}>
                <div><h3>Key Styles:</h3><ul>{resultData.dna.styles.map(s => <li key={s}>{s}</li>)}</ul></div>
                <div><h3>Your Palette:</h3><ul>{resultData.dna.palette.map(p => <li key={p}>{p}</li>)}</ul></div>
                <div><h3>Materials & Textures:</h3><ul>{resultData.dna.materials.map(m => <li key={m}>{m}</li>)}</ul></div>
                <div><h3>Your Mantra:</h3><p style={{fontSize: '1.5rem', fontWeight: 'bold'}}>"{resultData.dna.mantra}"</p></div>
            </div>

            <div style={styles.ctaSection}>
                <h2 style={{marginTop: 0}}>Ready to Shop Your Style?</h2>
                <p>We've curated a special collection on our main site just for the {resultData.title}.</p>
                
                {/* CHANGED: target="_blank" and rel="noopener noreferrer" are added to the collection link */}
                <a href={resultData.collectionUrl} target="_blank" rel="noopener noreferrer" style={styles.ctaButton}>
                    Explore {resultData.title} Collection
                </a>
                
                <br />
                
                {/* CHANGED: Restart button is now a simple <a> tag to force a full page reload */}
                <a href="/personality_test" style={styles.restartButton}>
                    Restart Quiz
                </a>
            </div>
        </div>
    );
}

export default ResultsPage;